import { TabPanel } from "@wordpress/components";
import { desktop, mobile, tablet } from "@wordpress/icons";
import {
    __experimentalText as Text,
    __experimentalView as View,
} from "@wordpress/components";
import UnitRange from "./UnitRange";

const ResponsiveRange = ({
    type,
    name,
    label,
    tabLabel,
    attributes,
    updateValue,
    onReset,
    max = 100,
    min = 0,
}) => {
    const handleUnitChange = (device, direction, newUnit) => {
        const currentSpacingKey = `${name}${
            device.charAt(0).toUpperCase() + device.slice(1)
        }`;

        const currentSpacing = attributes[currentSpacingKey] || {};

        const unitToUse = typeof newUnit === "object" ? newUnit.unit : newUnit;
        const valueToUse =
            typeof newUnit === "object"
                ? newUnit.value
                : currentSpacing[direction] || 0;

        updateValue(name, device, direction, valueToUse, unitToUse, true);
    };

    const handleValueChange = (device, direction, value) => {
        const currentSpacingKey = `${name}${
            device.charAt(0).toUpperCase() + device.slice(1)
        }`;
        const currentUnit =
            attributes[currentSpacingKey]?.[`${direction}Unit`] || "px";

        updateValue(name, device, direction, value, currentUnit, false);
    };

    const handleValueComplete = (device, direction, value) => {
        const currentSpacingKey = `${name}${
            device.charAt(0).toUpperCase() + device.slice(1)
        }`;
        const currentUnit =
            attributes[currentSpacingKey]?.[`${direction}Unit`] || "px";

        updateValue(name, device, direction, value, currentUnit, true);
    };

    const handleReset = (device) => {
        onReset(name, device);
    };

    const getDirections = () => {
        if (type === "single") {
            return ["value"];
        }

        const baseDirections = ["top", "right", "bottom", "left"];
        if (name === "margin") {
            return [...baseDirections, "blockStart", "blockEnd"];
        }
        return baseDirections;
    };

    const getLabel = (dir) => {
        if (type === "single") {
            return name.charAt(0).toUpperCase() + name.slice(1);
        }

        const labels = {
            blockStart: "Block Start",
            blockEnd: "Block End",
            top: "Top",
            right: "Right",
            bottom: "Bottom",
            left: "Left",
            value: name.charAt(0).toUpperCase() + name.slice(1),
        };
        return labels[dir];
    };

    return (
        <View className="responsive-range-container">
            <TabPanel
                className="custom-settings-tab spacing-device-tabs"
                activeClass="active-tab"
                tabs={[
                    {
                        name: "desktop",
                        title: "Desktop",
                        icon: desktop,
                    },
                    {
                        name: "tablet",
                        title: "Tablet",
                        icon: tablet,
                    },
                    {
                        name: "mobile",
                        title: "Mobile",
                        icon: mobile,
                    },
                ]}
            >
                {(deviceTab) => (
                    <>
                        <Text variant="subtitle" as="h3" className="tab-title">
                            {tabLabel ? tabLabel : ""}
                        </Text>
                        <View className="responsive-range-content">
                            {getDirections().map((direction) => (
                                <UnitRange
                                    key={`${name}-${direction}-${deviceTab.name}`}
                                    label={
                                        type === "single"
                                            ? label
                                            : getLabel(direction)
                                    }
                                    rangeValue={
                                        attributes[
                                            `${name}${
                                                deviceTab.name
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                deviceTab.name.slice(1)
                                            }`
                                        ]?.[direction] || 0
                                    }
                                    onRangeChange={(value) =>
                                        handleValueChange(
                                            deviceTab.name,
                                            direction,
                                            value
                                        )
                                    }
                                    onRangeComplete={(value) =>
                                        handleValueComplete(
                                            deviceTab.name,
                                            direction,
                                            value
                                        )
                                    }
                                    unitValue={{
                                        value:
                                            attributes[
                                                `${name}${
                                                    deviceTab.name
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                    deviceTab.name.slice(1)
                                                }`
                                            ]?.[direction] || 0,
                                        unit:
                                            attributes[
                                                `${name}${
                                                    deviceTab.name
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                    deviceTab.name.slice(1)
                                                }`
                                            ]?.[`${direction}Unit`] || "px",
                                    }}
                                    onUnitChange={(newUnit) =>
                                        handleUnitChange(
                                            deviceTab.name,
                                            direction,
                                            newUnit
                                        )
                                    }
                                    min={min}
                                    max={max}
                                />
                            ))}
                        </View>
                        <View className="responsive-range-reset">
                            <Text
                                as="button"
                                variant="link"
                                onClick={() => handleReset(deviceTab.name)}
                                className="reset-button"
                            >
                                Reset
                            </Text>
                        </View>
                    </>
                )}
            </TabPanel>
        </View>
    );
};

export default ResponsiveRange;
